export default __webpack_public_path__ + "static/media/gallery07.c506493a.webp";